import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {debounceTime, map} from 'rxjs/operators';
import {SoilAnalysisFileItem, SoilAnalysisUploadState, SoilAnalysisUploadStore} from './soil-analysis-upload.store';
import {combineLatest, Observable} from 'rxjs';
// import {SoilAnalysisFilesUploadingState} from '../../_shared/components/files-upload-info-box/constants/files-upload-state';
import {SoilAnalysisFileStatus} from './constants/soil-analysis-file-status';


@Injectable({providedIn: 'root'})
export class SoilAnalysisUploadQuery extends QueryEntity<SoilAnalysisUploadState, SoilAnalysisFileItem> {
  uploadingItems$: Observable<SoilAnalysisFileItem[]> = this.selectAll();
  uploading$: Observable<boolean> = this.uploadingItems$.pipe(
    map((items: SoilAnalysisFileItem[]) => {
      return items.some(item => item.data.status === SoilAnalysisFileStatus.Processing);
    })
  );
  uploadingInProgress$: Observable<boolean> = this.uploadingItems$
    .pipe(
    map((items: SoilAnalysisFileItem[]) => {
      return items.some(item => item.data.status === SoilAnalysisFileStatus.Processing);
    })
  );
  notUploaded$: Observable<SoilAnalysisFileItem[]> = this.uploadingItems$.pipe(
    map((items: SoilAnalysisFileItem[]) => {
      return items.filter(item => item.error);
    })
  );
  uploaded$: Observable<SoilAnalysisFileItem[]> = this.uploadingItems$.pipe(
    map((items: SoilAnalysisFileItem[]) => {
      return items.filter(item => !item.loading);
    })
  );

  // currentState$: Observable<SoilAnalysisFilesUploadingState> =
  // combineLatest(([this.uploading$, this.uploadingItems$, this.notUploaded$]))
  //   .pipe(map(([uploading, uploadingItems, notUploaded]) => {
  //     if (uploading) {
  //       return SoilAnalysisFilesUploadingState.Loading;
  //     } else if (notUploaded.length) {
  //       return SoilAnalysisFilesUploadingState.Error;
  //     } else if (uploadingItems.length) {
  //       return SoilAnalysisFilesUploadingState.Success;
  //     } else {
  //       return SoilAnalysisFilesUploadingState.Inactive;
  //     }
  //   }));

  constructor(protected store: SoilAnalysisUploadStore) {
    super(store);
  }
}
